module.exports = __webpack_public_path__ + "media/images/booking_preview-d7d493fcc056fbd9dec0a7f5c2177aef.png";